"use client";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { msalConfig } from "../common/functions/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

export const AuthWrapper = ({ children }) => {
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		async function initMSAL() {
			await msalInstance.initialize();
		}
		initMSAL().then(() => {
			setInitialized(true);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<MsalProvider instance={msalInstance}>
			{initialized && children}
		</MsalProvider>
	);
};
